export default {
	title: "Service Tickets",
	goToAttendance: "Distribute Tickets",
	consultant: "Consultant",
	medium: "Medium",
	guide: "Guide",
	startAttendance: "Start Service",
	finishAttendance: "Finish Service",
	cancel: "Cancel",
	notes: "Notes",
	addObservation: "Add Observation",
	observation: "Observation",
	attendanceCard: "Attendance Card",
	pendingTickets: "Pending Tickets",
	status: {
		PENDING: "Pending",
		IN_PROGRESS: "In Progress",
		COMPLETED: "Completed",
		CANCELLED: "Cancelled",
	},
	cancelledAt: "Cancelled at",
	confirmStatusChange: "Confirm Status Change",
	createdAt: "Created at",
	deleteConfirmation: "Are you sure you want to delete the ticket {code}?",
	finishedAt: "Finished at",
	noTicketsDescription: "This person has no attendance tickets yet",
	noTicketsFound: "No tickets found",
	notAssigned: "Not assigned",
	print: "Print",
	startedAt: "Started at",
	statusChangeConfirmation: "Do you want to change the status of ticket {code} to {status}?",
	statusLabel: "Status",
	ticketDetails: "Ticket Details",
	timeline: {
		daysSinceLastVisit: "days without attendance",
		startedIn: "Started in",
		today: "Today",
	},
	messages: {
		ticketCreated: "Ticket {code} created successfully",
		ticketUpdated: "Ticket updated successfully",
		ticketCancelled: "Ticket cancelled",
		ticketDeleted: "Ticket deleted successfully",
		statusUpdated: "Ticket status updated",
		loadError: "Error loading tickets",
		observationAdded: "Observation updated successfully",
		errorFetching: "Error loading tickets",
		errorUpdating: "Error updating ticket",
	},
	table: {
		headers: {
			code: "Code",
			consultant: "Consultant",
			medium: "Medium",
			attendanceCard: "Attendance Card",
			guide: "Guide",
			status: "Status",
		},
	},
	personAttendances: {
		title: "Attendances",
		received: "Received",
		given: "Given",
		timeline: "Timeline",
		list: "List",
	},
	mediumAttendances: {
		title: "Attendances Given",
		exportPdf: "Export PDF",
		pdfError: "Error generating the attendances PDF",
		empty: "No attendances found in the period",
		filters: {
			thisYear: "This year",
		},
		kpis: {
			attendances: "Attendances",
			rituals: "Rituals",
			totalTime: "Total time",
			avgTime: "Average time",
		},
		table: {
			date: "Date",
			ritual: "Ritual",
			duration: "Duration",
		},
	},
};
